import { useState, useMemo, useEffect } from 'react';
import TabsUI from '../Interface/TabsUI';

import TodoContent from './TaskListTodoContent';
import useParam from '../../context/ParamContext';
import masterDataService from '../../service/masterData.service';
import useMenus from '../../context/MenuContext';
import { generateAutocompleteItems } from '../../utils/helper';
import useUsers from '../../context/UsersContext';

const TaskListTodoPage = () => {
  const { menus, getMenus, getMenuSubMenuId } = useMenus();
  const { getParam } = useParam();
  const { getUser, user, getRole } = useUsers();
  const [activeTab, setActiveTab] = useState(0);
  const [submenu, setSubmenu] = useState(null);
  const [autoCompleteOptions, setAutoCompleteOptions] = useState({
    status: [],
    project: [],
    user: [],
    userGroups: [],
  });
  const [autoCompleteData, setAutoCompleteData] = useState({});

  useEffect(() => {
    getMenus();
    getParam();
    if (!Object.keys(user).length) getUser();
  }, []);

  useEffect(() => {
    if (submenu) initDefaultValues();
  }, [submenu]);

  useEffect(() => {
    setSubmenu(getMenuSubMenuId('simpleTask'));
  }, [menus]);

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .usersToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .userGroupsToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          status: resp[0],
          project: resp[1],
          user: resp[2],
          userGroups: resp[3],
        };
        setAutoCompleteData(aData);

        const acOptions = {
          status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
          project: generateAutocompleteItems(aData.project, ['projectName', 'orderNumber'], 'projectId'),
          user: generateAutocompleteItems(aData.user, 'nickName', 'userId'),
          userGroups: generateAutocompleteItems(aData.userGroups, 'name', 'id'),
        };
        setAutoCompleteOptions(acOptions);
      })
      .finally(() => {
        //hideLoader();
      });
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const TodoContentMemo = useMemo(() => (p) => <TodoContent activeTab={activeTab} {...p} />, [activeTab]);

  const todoTabs = [
    {
      id: 0,
      name: 'Saját',
      content: (
        <TodoContentMemo
          type={'own'}
          tabId={0}
          autoCompleteOptions={autoCompleteOptions}
          autoCompleteData={autoCompleteData}
          user={user}
          getRole={getRole}
        />
      ),
    },
    {
      id: 1,
      name: 'Csoport',
      content: (
        <TodoContentMemo
          type={'group'}
          tabId={1}
          autoCompleteOptions={autoCompleteOptions}
          user={user}
          getRole={getRole}
        />
      ),
    },
    {
      id: 2,
      name: 'Nyitott',
      content: (
        <TodoContentMemo
          type={'opened'}
          tabId={2}
          autoCompleteOptions={autoCompleteOptions}
          user={user}
          getRole={getRole}
        />
      ),
    },
    {
      id: 3,
      name: 'Összes',
      content: (
        <TodoContentMemo
          type={'all'}
          tabId={3}
          autoCompleteOptions={autoCompleteOptions}
          user={user}
          getRole={getRole}
        />
      ),
    },
  ];

  return (
    <div className="gap-4 bg-gray-100 min-h-full p-4">
      <div className="flex justify-center w-full mr-auto ml-auto">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {todoTabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default TaskListTodoPage;
